module.exports = __webpack_public_path__ + "static/5th-anniversary-Npay-9e51cb8ab88023c8f014d01587332ea4.png";